import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

import { ArrowBack } from '@bibliocommons/base-icons';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { childrenShape } from '@bibliocommons/bc-prop-types';
import Heading from '@bibliocommons/heading';

import './BrowseSearchPage.scss';

const BrowseSearchPage = ({ backToLinkProps, children, heading }) => {
  const { href, label, screenReaderLabel } = backToLinkProps;

  return (
    <article className="cp-browse-search-page">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <header>
              <Link className="back-to-link" dataKey="back-to-browse" to={href}>
                <ArrowBack />
                <span aria-hidden>{label}</span>
                <ScreenReaderMessage>{screenReaderLabel}</ScreenReaderMessage>
              </Link>
              <Heading className="heading-primary" size="large" tagName="h1" variant>
                {heading}
              </Heading>
            </header>
          </div>
        </div>
        {children}
      </div>
    </article>
  );
};

BrowseSearchPage.propTypes = {
  backToLinkProps: PropTypes.shape({
    href: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    screenReaderLabel: PropTypes.string.isRequired
  }).isRequired,
  children: childrenShape.isRequired,
  heading: PropTypes.string.isRequired
};

export default BrowseSearchPage;
